import React from "react";
import InquiryForm from "./InquiryForm";
import { Disclosure } from "./Disclosure";
import { REQUEST_CALL } from "../data/inquiryForms";
import "../pages/Offerings.css";

/**
 * "Request a call" (her November 2026 corrections), in place of the free
 * 15-minute consultation that used to be booked online. Name, email, phone
 * and the times that suit them, plus an optional note; it posts to
 * POST /api/public/contact as a message starting "Call request", so it lands
 * in her Messages.
 *
 * @param {object} props
 * @param {boolean} [props.collapsible] - Closed behind a "Request a call"
 *   heading button (service, bundle and in-home pages); open on Home
 * @param {2|3} [props.headingLevel] - Level of the heading, default 2
 */
export default function RequestCallForm({ collapsible = false, headingLevel = 2 }) {
  if (collapsible) {
    return (
      <div className="request-call">
        <Disclosure title={REQUEST_CALL.heading} level={headingLevel}>
          <InquiryForm form={REQUEST_CALL} showHeading={false} />
        </Disclosure>
      </div>
    );
  }
  return (
    <div className="request-call" id="request-a-call">
      <InquiryForm form={REQUEST_CALL} headingLevel={headingLevel} />
    </div>
  );
}
